import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FormComponent } from './form/form.component';
import { OverviewComponent } from './overview/overview.component';

const routes: Routes = [
  {
    path: 'stor/new',
    component: FormComponent,
  },
  {
    path: 'stor/edit',
    component: FormComponent,
  },
  {
    path: 'stor/overview',
    component: OverviewComponent,
  },
  {
    path: '**',
    component: DashboardComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
